import * as React from "react";
import styled from "styled-components";
import { BREAK_POINTS } from "../../consts/style";

const ShowPhone = styled.div`
  @media (min-width: ${(p: { width: string }) => p.width}) {
    display: none;
  }
`;
const ShowNoPhone = styled.div`
  display: none;
  @media (min-width: ${(p: { width: string }) => p.width}) {
    display: block;
  }
`;

export const PhoneNoPhone = ({
  width = BREAK_POINTS.MIN.SM,
  phone,
  noPhone
}: {
  width?: string;
  phone: React.ReactNode;
  noPhone: React.ReactNode;
}) => (
  <>
    <ShowPhone width={width}>{phone}</ShowPhone>
    <ShowNoPhone width={width}>{noPhone}</ShowNoPhone>
  </>
);
